export const SET_AVAILABILITY_PAGE_STATUS = 'SET_AVAILABILITY_PAGE_STATUS';
export const SET_SIGN_IN_PAGE = 'SET_SIGN_IN_PAGE';
export const SET_SIGN_IN_PAGE_TEXT = 'SET_SIGN_IN_PAGE_TEXT';
export const SET_SPLASH_STATUS = 'SET_SPLASH_STATUS';
export const SET_STRIPE_MODAL_STATUS = 'SET_STRIPE_MODAL_STATUS';
